import { Link } from "gatsby"
import React from "react"
import { DemosearchTenderHit } from "components/page-components/Ausschreibungsdienste/demosearch/hit-components"

export const DemoTender = ({ demo_tender_data, ressort }) => {
  const {
    demo_tender_query_string,
    demo_tender_number_of_hits,
    demo_tender_hit,
    demo_tender_category_title,
  } = demo_tender_data
  return (
    <div data-nosnippet className="mt-5">
      <p
        className={`title is-4 is-size-5-mobile has-text-${
          ressort ? ressort : "mitternachtsblau"
        } mb-3`}
      >
        Aktuelle Ausschreibung
      </p>
      <hr className="mt-3 " />
      <DemosearchTenderHit
        {...{
          hit: demo_tender_hit,
          is_bfz_module: true,
          no_flex: true,
        }}
      />
      <div className="has-text-centered mb-4">
        <Link
          className="is-underlined"
          to={`/ausschreibungsdienste${
            !!demo_tender_query_string
              ? `#demosearch-box&${demo_tender_query_string}`
              : ""
          }`}
        >
          <b>
            {demo_tender_number_of_hits
              ? `${demo_tender_number_of_hits} w`
              : "W"}
            eitere
          </b>{" "}
          Ausschreibungen für {demo_tender_category_title || "Sie"} anzeigen
        </Link>
      </div>
      <hr className="" />
    </div>
  )
}
